export interface ErrorMessage {
  message: string;
  description: string;
}

export const ErrorDictionary = {
  AGS_01: {
    message: "Insufficient Margin. User has insufficient funds to start a bot",
    description: "",
  },
  AGS_02: {
    message: "Incorrect Grid Settings. Order amount cannot be less than order step",
    description: "Order amount cannot be less than order step",
  },
  AGS_03: {
    message: "Price levels below zero",
    description: "Price levels cannot be below zero",
  },
  AGS_04: {
    message: "Invalid Credentials",
    description: "Provided credentials are invalid",
  },
  AGS_05: {
    message: "Invalid Leverage",
    description: "Leverage can not be different from other bots' leverage on the same ticker",
  },
  AGS_06: {
    message: "Invalid Order Amount",
    description: "Order amount precision is invalid",
  },
  AGS_07: {
    message: "Invalid price precision",
    description: "Order price precision is invalid",
  },
  BMNG_00: {
    message: "Validation error",
    description: "",
  },
  BMNG_01: {
    message: "Bot not found by id = $botId",
    description: "",
  },
  BMNG_02: {
    message: "Zero active orders found while cycling this bot",
    description: "",
  },
  BMNG_03: {
    message: "Couldn't close bot with id = $botId\nIncorrect status $status",
    description: "",
  },
  BMNG_04: {
    message: "Order not found by id = $orderId",
    description: "",
  },
  BMNG_05: {
    message: "Bot creation failure. Reached limit of bots ($maxActiveBots)",
    description: "",
  },
  BMNG_06: {
    message: "Invalid or prohibited sort key $key",
    description: "",
  },
  BMNG_07: {
    message: "Expected at least one of these params: profileId, accountId",
    description: "",
  },
  BMNG_08: {
    message: "Account not found by id = $accountId",
    description: "",
  },
  BMNG_09: {
    message: "",
    description: "",
  },
  BMNG_10: {
    message: "Notional order amount too small. Orders do not meet minimum order value.",
    description: "",
  },
  BMNG_11: {
    message: "Can't update order. Incorrect order type $type",
    description: "",
  },
  BENG_01: {
    message: "Insufficient Margin",
    description: "User has insufficient funds to start a bot",
  },
  BENG_02: {
    message: "Incorrect Grid Settings",
    description: "Order amount is less than orderStep",
  },
  BENG_03: {
    message: "Incorrect Grid Settings",
    description: "Price levels below zero exist",
  },
  BENG_04: {
    message: "Incorrect Grid Settings",
    description: "Price step is invalid",
  },
  BENG_05: {
    message: "Invalid Credentials",
    description: "Provided credentials are incorrect",
  },
  BENG_06: {
    message: "Position Liquidated",
    description: "User position was liquidated",
  },
  BENG_07: {
    message: "Exceptional Margin Utilization",
    description:
      "Too much funds are locked in limit orders at the moment, order creation temporary suspended",
  },
  BENG_09: {
    message: "Invalid Leverage",
    description: "Leverage can not be different from other bots' leverage on the same ticker",
  },
  BENG_10: {
    message: "Possible Liquidation",
    description: "Position will be soon liquidated",
  },
  BENG_12: {
    message: "Unspecified Error",
    description: "Unexpected error occured that lead to bot closing",
  },
  BENG_13: {
    message: "Canceled Order Detected",
    description: "Bot order was canceled",
  },
  BENG_14: {
    message: "Position Out Of Range",
    description: "Attempted to open position more than allowed",
  },
  BENG_15: {
    message: "Cancel Orders Unsuccessful",
    description: "Was not able to close all open limit orders after  $limit attempts.",
  },
  BENG_16: {
    message: "Service Unavailable",
    description: "Exchange $exchange Unavailable",
  },
  BENG_17: {
    message: "Invalid Initial Price",
    description: "Initial price precision is invalid",
  },
  BENG_18: {
    message: "",
    description: "",
  },
  BENG_19: {
    message: "",
    description: "Margin not enough for new leverage",
  },
  BENG_20: {
    message: "",
    description: "Not Enough Margin To Open Order",
  },
  BENG_21: {
    message: "",
    description: "Order Not Found Exception",
  },
};
